export { default } from './CategoryBand';
